module.exports = __webpack_public_path__ + "img/desc1.b54e2da4.png";